import Skeleton from '../Skeleton';
import { LectureVideoPlayer } from '../video/LectureVideoPlayer';
import { LectureCategory } from '../../lib/types';
import { cn } from '../../lib/helpers';

export const Video = ({
    slug,
    category,
    posterClassName,
    className,
}: {
    slug: string;
    category: LectureCategory;
    posterClassName?: string;
    className?: string;
}) => {
    const video = category.lectures?.find((lecture) => lecture.slug === slug);

    return (
        <div className={cn("w-full max-w-[892px] flex-1", className)}>
            {video && (
                <LectureVideoPlayer
                    isActive={true}
                    poster={video.video.poster}
                    src={video.video.url}
                    posterClassName={posterClassName}
                />
            )}
            {!video && <Skeleton className="min-h-40 w-full rounded rounded-xl" />}
        </div>
    );
};
